<!-- 主按钮 -->
<template>
  <div class="primaryBtn" :style="bgStyle" @click="handleClick"></div>
</template>

<script>
import handleRedirect from '../mixins/pureHandleRedirect';
export default {
  mixins: [handleRedirect],
  props: {
    buttonImage: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'component_expo',
      module_name: this.$t ? this.$t('track.base_comp_primary_btn') : '普通按钮'
    });
  },
  methods: {
    handleClick() {
      this.$emit('reportEvent', {
        event: 'component_button_click',
        module_name: this.$t
          ? this.$t('track.base_comp_primary_btn')
          : '普通按钮'
      });
      this.handleRedirect();
    }
  },
  computed: {
    bgStyle() {
      return {
        background: `center / contain url("${this.buttonImage}") no-repeat`
      };
    }
  }
};
</script>
<style lang="less" scoped>
.primaryBtn {
  margin: 0 auto;
  width: 560px;
  height: 88px;
}
</style>
